// extracted by extract-css-chunks-webpack-plugin
module.exports = {"buttons":"KW7zGm","tabSlider":"_15KE2P","button":"z2i_Jl","active":"_2ibBAJ","next":"_1Nule0","prev":"-_1QYO"};